import React from 'react'

const Header = function header ({formlogin,onChangeLogin,onSubmitLogin}){
    return (
        <section className="sectionFormLogin">
            <div className="row rowOne">
                <div className="col s12">
                    <img src={https+"img/film_crispetas.jpg"} alt=""/>
                </div>
                <div className="col m12 l6 s12">
                    <div className="row">
                        <form id="formLogin" action="" onSubmit={onSubmitLogin}>
                            <div className="col s12">
                                <h1>
                                    Iniciar Sesion <br/>
                                    <hr/>
                                </h1>
                            </div>
                            <input
                                type="hidden"
                                name="token"
                                value={formlogin.token}
                                onChange={onChangeLogin}
                            />
                            <div className="col s12 input-field">
                                <h6>Usuario</h6>
                                <input
                                    name="user"
                                    type="text"
                                    value={formlogin.user}
                                    onChange={onChangeLogin}
                                />
                            </div>
                            <div className="col s12 input-field">
                                <h6>Contraseña</h6>
                                <input
                                    name="password"
                                    type="password"
                                    value={formlogin.password}
                                    onChange={onChangeLogin}
                                />
                            </div>
                            <div className="col s12">
                                <div className="boton">
                                    <button type="submit">
                                        <a className="waves-effect waves-light btn">Acceder</a>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>

    )
}

export default Header
